import Dropdown, { DropdownWrapper } from '@anm/components/Dropdown';
import Button from '@anm/components/buttons/Button';
import Image from '@anm/components/image/Image';
import isMobileOrIPad from '@anm/helpers/is/isMobileOrIPad';
import { commonInputStyles, flexCenter, flexRow, media } from '@anm/styles/helpers';
import styled, { css } from 'styled-components';

import { CellProps } from './types';

const CELL_WIDTH = isMobileOrIPad() ? 45 : 32;

export const CalendarButton = styled(Button)``;

export const DayCell = styled.div`
  height: 44px;
  cursor: default;
  line-height: 44px;
  width: ${CELL_WIDTH}px;
`;

export const DaysWrapper = styled.div`
  ${flexRow};
  ${flexCenter};
  color: #919eaa;
  font-size: 12px;
  text-align: center;
`;

export const DatesWrapper = styled.div`
  ${flexRow};
  flex-wrap: wrap;
  align-content: baseline;
  max-width: ${7 * CELL_WIDTH}px;
  min-height: ${6 * CELL_WIDTH}px;
`;

export const DatesTableWrapper = styled.div`
  cursor: default;
`;

const disabledDateStyles = css`
  color: #919eaa;
  cursor: default;
  pointer-events: none;
`;

const selectedDateStyles = css<CellProps>`
  &:before {
    content: '';
    z-index: -1;
    height: 100%;
    position: absolute;
    background: #f5f7fa;
    left: ${({ isEndDate }) => (isEndDate ? 0 : '50%')};
    width: ${({ isSelectedOneDay }) => (isSelectedOneDay ? 0 : 50)}%;
  }
`;

export const DateCell = styled.div<CellProps>`
  ${flexCenter};
  position: relative;
  cursor: pointer;
  font-size: 14px;
  text-align: center;
  width: ${CELL_WIDTH}px;
  height: ${CELL_WIDTH}px;
  line-height: ${CELL_WIDTH}px;
  background-color: ${({ color }) => color};
  border-radius: ${({ isSelected }) => (isSelected ? '50%' : 0)};
  color: ${({ isSelected }) => (isSelected ? '#fff' : '#292A2B')};
  ${({ isDisabled }) => isDisabled && disabledDateStyles};
  ${({ isStartDate, isEndDate, isRangeDate }) => (isStartDate || isEndDate) && isRangeDate && selectedDateStyles};
`;

export const Input = styled.input`
  width: 100%;
  height: 40px;
  display: flex;
  flex: 1 0 100%;
  font-size: 16px;
  margin-left: 8px;
  padding: 10px 12px;
  ${commonInputStyles};
`;

const arrowOnMobile = media.phone`
  border: 1px solid #cbdce5;
  padding: 12px 15px;

`;

const arrowCommonStyles = css`
  top: 17px;
  padding: 10px;
  cursor: pointer;
  position: absolute;
  border-radius: 5px;
  ${arrowOnMobile};
`;

const nextButtonOnMobile = media.phone`
  right: 13px;
`;

export const NextButton = styled(Image)`
  ${arrowCommonStyles};
  right: 10px;
  transform: rotate(180deg);
  ${nextButtonOnMobile};
`;

const prevButtonOnMobile = media.phone`
  left: 13px;
`;

export const PrevButton = styled(Image)`
  ${arrowCommonStyles};
  left: 10px;
  ${prevButtonOnMobile};
`;

const dropdownContainerOnMobile = media.phone`
  top: unset;
  bottom: 30px;
`;

export const DropdownContainer = styled(Dropdown)`
  &:before,
  &:after {
    display: none;
  }
  ${dropdownContainerOnMobile};
`;

const datePickerContentWrapperOnMobile = media.phone`
  padding: 14px 13px 20px;
`;

export const DatePickerContentWrapper = styled.div`
  ${flexRow};
  flex-wrap: wrap;
  position: relative;
  padding: 10px 16px 24px;
  justify-content: space-between;
  ${CalendarButton} {
    margin-top: 10px;
    min-width: 107px;
  }
  ${datePickerContentWrapperOnMobile};
`;

export const TablesWrapper = styled.div`
  ${flexRow};
  & > ${DatesTableWrapper}:nth-child(2) {
    margin-left: 20px;
  }
`;

export const TableLabel = styled.p`
  margin: 0;
  color: #292a2b;
  cursor: default;
  font-size: 16px;
  font-weight: bold;
  line-height: 45px;
  user-select: none;
  text-align: center;
`;

export const ActionListWrapper = styled.div`
  width: 100%;
  max-width: 100%;
  padding: 10px 0;
  min-width: 300px;
`;

export const ActionItem = styled.p`
  margin: 0;
  width: inherit;
  padding: 0 20px;
  cursor: pointer;
  line-height: 45px;
  &:hover {
    background: rgba(32, 171, 210, 0.1);
  }
  &:last-child {
    border-top: 1px solid #ccdde6;
  }
`;

export const DropdownArrow = styled(Image)<{ active: number }>`
  top: 17px;
  right: 10px;
  max-height: 10px;
  position: absolute;
  pointer-events: none;
  transform: ${({ active }) => (active ? 'rotate(180deg)' : 'rotate(0deg)')};
`;

const dropdownWrapperOnMobile = media.phone`
  min-width: unset;
`;

const Wrapper = styled.div`
  height: 100%;
  position: relative;

  & > div {
    min-height: 38px;
    align-items: flex-start;
  }

  ${DropdownWrapper} > div {
    min-width: 100%;
    ${dropdownWrapperOnMobile};
  }
`;

export default Wrapper;
